<template>
  <div class="app-container">
    <!-- 工具栏 -->
    <div class="topbar">
      <div class="left">
        <el-input v-model="searchValue" placeholder="" size="small"
                  style="margin-right: 15px" @keyup.enter.native="search()"/>
        <el-button type="primary" size="small" @click="search()">
          {{ $t("search") }}

        </el-button>
      </div>

    </div>

    <!-- 表格 -->
    <el-table v-loading="loading" :data="dataList" :header-cell-style="{ background: '#F5F7FA' }"
              style="width: 100%; margin-bottom: 20px" stripe border>
      <el-table-column label="用户" prop="listingDate" align="center">
        <template #default="scope">
          <user-info :user="scope.row"></user-info>
        </template>
      </el-table-column>
      <el-table-column label="系列" prop="seriesName" align="center"></el-table-column>
      <el-table-column label="版本号" prop="version" align="center"></el-table-column>
      <el-table-column label="型号" prop="model" align="center"></el-table-column>
      <el-table-column label="编号" prop="number" align="center"></el-table-column>
      <el-table-column label="产品图片" prop="picUrl" align="center">
        <template #default="scope">
          <el-image :src="getImageUrl(scope.row.picUrl)" :preview-src-list="[getImageUrl(scope.row.picUrl)]"></el-image>
        </template>
      </el-table-column>
      <el-table-column label="产品描述" prop="produceDesc" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="生产日期" prop="listingDate" align="center">
        <template #default="scope">
          {{ scope.row.listingDate | formatDateTime }}
        </template>
      </el-table-column>

    </el-table>

    <el-pagination background
                   :page-size="pageOpt.pageSize" :total="pageOpt.total" :current-page="pageOpt.currentPage"
                   @current-change="currentChange"/>
  </div>

</template>

<script>
import {getUserSeriesVoList} from "@/api/system/CSDocument/user";
import {handleRes} from "@/utils/handleRes";
import UserInfo from "@/components/UserInfo/UserInfo";
import {getCloudUrl} from "@/utils/urlutil";

export default {
  name: "userSeriesVoList",
  components: {UserInfo},
  data() {
    return {
      loading: false,
      searchValue: "",
      pageOpt: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      dataList: [],
    }
  },
  created() {
    this.refreshList()
  },
  methods: {
    getImageUrl(path) {
      return getCloudUrl(path)
    },
    refreshList() {
      this.pageOpt.currentPage = 1
      this.getUserSeriesVoList()
    },
    search() {
      this.refreshList()
    },
    currentChange(curPage) {
      this.pageOpt.currentPage = curPage
      this.getUserSeriesVoList()
    },
    getUserSeriesVoList() {
      this.loading = true
      let params = {
        pageSize: this.pageOpt.pageSize,
        keyWord: this.searchValue,
        pageNumber: this.pageOpt.currentPage,
        sortName:'seriesId'
      }
      getUserSeriesVoList(params).then(res => {
        handleRes(res, () => {
          this.dataList = res.data.rows
          this.pageOpt.total = res.data.total
        })
        this.loading = false
      })
    },
  }
}
</script>

<style scoped>

</style>